var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('video',{attrs:{"id":"demo-video","controls":"","width":"100%"}},[_c('source',{attrs:{"src":_vm.url,"type":"video/mp4","height":"200"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }